module.exports = __webpack_public_path__ + "static/img/图层 33.57349c4c.png";